$('body').on('click', '.accordion-header', function () {
    var $item = $(this).parents('.accordion-item');
    var $body = $item.find('.accordion-body');

    if ($body.is(':visible')) {
        $body.slideUp();
        $item.removeClass('active');
    } else {
        $('.accordion-body').slideUp();
        $('.accordion-item').removeClass('active'); // remove active from all
        $body.slideDown();
        $item.addClass('active'); // add active to current
    }
});

// product slide counter js
$(document).ready(function () {
  
  let $list = $("ul.loil.product__media-list.contains-media.grid.grid--peek.list-unstyled.slider.slider--mobile");
  let $items = $list.find("li");

  function checkVisible() {
    let windowTop = $(window).scrollTop();
    let windowBottom = windowTop + $(window).height();

    $items.each(function (i) {
      let $el = $(this);
      let elTop = $el.offset().top;
      let elBottom = elTop + $el.height();

      // Agar element 50% se zyada visible hai
      if (elBottom > windowTop + $el.height() / 2 && elTop < windowBottom - $el.height() / 2) {
        let index = i + 1; // 1-based index
        console.log("Visible slide number:", index);
      $('.counter-numbering span.updateing--count').text(index)
        // Counter update karna ho to:
        $(".slider-counter--current").text(index);
        return false; // ek hi visible consider karna hai to loop break
      }
    });
  }

  $(window).on("scroll", checkVisible);
    checkVisible(); // on load bhi run
});



$(document).ready(function () {
    let path = window.location.pathname;
 if (path.indexOf('/pages/') !== -1) {
        let pagePart = path.split('/pages/')[1]; 
        console.log("URL part after '/pages/':", pagePart);
     $('.pages--tabs--heading h2').each(function () {
            let headingText = $(this).text().trim();
          let handle = headingText.toLowerCase()
                .replace(/\s+/g, '-')    
                .replace(/[^\w\-]+/g, '') 
                .replace(/\-\-+/g, '-')  
                .replace(/^-+/, '')     
                .replace(/-+$/, '');     

            console.log("Heading text:", headingText);
            console.log("Handle size:", handle);

            if(pagePart == handle){
               $('.pages--tabs--heading h2').removeClass('active');
                $(this).addClass('active');
            }
        });
    }
});


